/**
 * セレクトボックスでプレースホルダーを再現
 * 
 */

export module SelectBoxPlaceholderModule {
  export class Service {
    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.setEvent();
      });
    }

    public static setEvent() {
      const $selectboxs = document.querySelectorAll<HTMLInputElement>('.selectWrap .isPlaceholder select');
      if ($selectboxs) {
        $selectboxs.forEach($selectbox => {
          const $selectWrap = $selectbox.closest('.selectWrap');
          const $isPlaceholder = $selectbox.closest('.isPlaceholder');
          if ($selectWrap && $selectbox && $isPlaceholder) {
            if ('' === $selectbox.value) {
              $isPlaceholder.classList.add('isEmpty');
            }

            $selectbox.addEventListener('change', () => {
              if ('' === $selectbox.value) {
                $isPlaceholder.classList.add('isEmpty');
              } else {
                $isPlaceholder.classList.remove('isEmpty');
              }
            });
          }
        });
      }
    }
  }
}

